import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  List,
  ListItemButton,
  ListItemText,
  Typography,
  Box,
  Container,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import React, { useState } from "react";
import Breadcrumb from "../../../Shared-ui/SharedComponents/Breadcrumb";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";

const Help = () => {
  const [expanded, setExpanded] = useState("gettingStarted");
  const [selected, setSelected] = useState("introduction");

  return (
    <Container maxWidth="xl" sx={{ py: 3 }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: { md: "flex-end", sm: "flex-start" },
            gap: { md: "10px", sm: "0" },
            flexDirection: { md: "row", sm: "column", xs: "column" },
          }}
        >
          <Breadcrumb data={[{ name: "Help", path: "" }]} />
        </Box>
      </Box>
      <Box
        sx={{
          display: "flex",
          gap: 8,
        }}
      >
        {/* Left Menu */}
        <Box
          sx={{
            width: "300px",
            borderRight: "1px solid",
            borderColor: "divider",
            pr: 2,
            height: "calc(100vh - 215px)",
          }}
        >
          <Accordion
            expanded={expanded === "gettingStarted"}
            onChange={() =>
              setExpanded(expanded === "gettingStarted" ? "" : "gettingStarted")
            }
            disableGutters
            elevation={0}
            sx={{
              boxShadow: "none",
              border: "none",
              "&::before": { display: "none" },
            }}
          >
            <AccordionSummary
              expandIcon={
                expanded === "gettingStarted" ? (
                  <KeyboardArrowUpIcon sx={{ fontSize: 22 }} />
                ) : (
                  <KeyboardArrowRightIcon sx={{ fontSize: 22 }} />
                )
              }
              sx={{
                flexDirection: "row-reverse",
                pl: 0,
                minHeight: 36,
                "& .MuiAccordionSummary-content": {
                  my: 1,
                },
              }}
            >
              <Typography variant="body1">Getting started</Typography>
            </AccordionSummary>
            <AccordionDetails
              sx={{
                p: "0 0 0 24px",
                position: "relative",
                "&::before": {
                  content: '""',
                  position: "absolute",
                  left: "11px",
                  top: 0,
                  width: "1px",
                  height: "100%",
                  backgroundColor: "divider",
                },
              }}
            >
              <List disablePadding>
                <ListItemButton
                  selected={selected === "introduction"}
                  onClick={() => setSelected("introduction")}
                  sx={{
                    borderRadius: 1,
                    "& .MuiListItemText-root": {
                      my: 0,
                    },
                  }}
                >
                  <ListItemText primary="Introduction" />
                </ListItemButton>
                <ListItemButton
                  selected={selected === "appOverview"}
                  onClick={() => setSelected("appOverview")}
                  sx={{
                    borderRadius: 1,
                    "& .MuiListItemText-root": {
                      my: 0,
                    },
                  }}
                >
                  <ListItemText primary="App Overview" />
                </ListItemButton>
                <ListItemButton
                  selected={selected === "createAgent"}
                  onClick={() => setSelected("createAgent")}
                  sx={{
                    borderRadius: 1,
                    "& .MuiListItemText-root": {
                      my: 0,
                    },
                  }}
                >
                  <ListItemText primary="Create Your First Agent" />
                </ListItemButton>
              </List>
            </AccordionDetails>
          </Accordion>
          <Accordion
            expanded={expanded === "agents"}
            onChange={() => setExpanded(expanded === "agents" ? "" : "agents")}
            disableGutters
            elevation={0}
            sx={{
              boxShadow: "none",
              border: "none",
              "&::before": { display: "none" },
            }}
          >
            <AccordionSummary
              expandIcon={
                expanded === "agents" ? (
                  <KeyboardArrowUpIcon sx={{ fontSize: 22 }} />
                ) : (
                  <KeyboardArrowRightIcon sx={{ fontSize: 22 }} />
                )
              }
              sx={{
                flexDirection: "row-reverse",
                pl: 0,
                minHeight: 36,
                "& .MuiAccordionSummary-content": {
                  m: "8px 0",
                },
              }}
            >
              <Typography fontWeight={500}>Agents</Typography>
            </AccordionSummary>
            <AccordionDetails
              sx={{
                p: "0 0 0 24px",
                position: "relative",
                "&::before": {
                  content: '""',
                  position: "absolute",
                  left: "11px",
                  top: 0,
                  width: "1px",
                  height: "100%",
                  backgroundColor: "divider",
                },
              }}
            >
              <List disablePadding>
                <ListItemButton
                  selected={selected === "introduction"}
                  onClick={() => setSelected("introduction")}
                  sx={{
                    borderRadius: 1,
                    "& .MuiListItemText-root": {
                      my: 0,
                    },
                  }}
                >
                  <ListItemText primary="Introduction" />
                </ListItemButton>
                <ListItemButton
                  selected={selected === "appOverview"}
                  onClick={() => setSelected("appOverview")}
                  sx={{
                    borderRadius: 1,
                    "& .MuiListItemText-root": {
                      my: 0,
                    },
                  }}
                >
                  <ListItemText primary="App Overview" />
                </ListItemButton>
                <ListItemButton
                  selected={selected === "createAgent"}
                  onClick={() => setSelected("createAgent")}
                  sx={{
                    borderRadius: 1,
                    "& .MuiListItemText-root": {
                      my: 0,
                    },
                  }}
                >
                  <ListItemText primary="Create Your First Agent" />
                </ListItemButton>
              </List>
            </AccordionDetails>
          </Accordion>
        </Box>
        {/* Right Content */}
        <Box
          sx={{
            display: "flex",
            flex: 1,
          }}
        >
          Right
        </Box>
      </Box>
    </Container>
  );
};

export default Help;
